import gql from "graphql-tag";

export const changeReservationDate = gql`
  mutation changeReservationDate($reservationUuid: String!, $eventId: String!){
    response: changeReservationDate(reservationUuid: $reservationUuid, eventId: $eventId){
      _id
    }
  }
`;
